import { NAVY, AMBER, BORDER_COLOR } from '../../styles/tokens';
import { useAuth, userVeVacaciones } from '../../context/AuthContext';

/**
 * V65 — La barra de pestañas del dashboard general, extraída.
 *
 * POR QUÉ SE EXTRAJO: estaba escrita DOS VECES —una dentro del cuerpo de Gastos y otra
 * dentro del de Nómina—, y agregar Vacaciones habría hecho una tercera copia. Tres
 * expresiones de "cuáles son las pestañas y quién las ve" es exactamente el patrón que
 * la serie viene cerrando: alcanza con que alguien agregue una pestaña en dos de los
 * tres lugares para que aparezca y desaparezca según desde dónde se entre.
 *
 * ⚠ Las dos copias no eran idénticas: la de Nómina gateaba el <h2> con `!hideTabs` y la
 * de Gastos no. Era inocuo solo porque `hideTabs` se usa únicamente con
 * `initialTab="nomina"`. Acá se unifica al comportamiento de Nómina, que es el correcto.
 *
 * ⚠ VACACIONES la ven casi todos, pero NO el chofer — y el gate sale de
 * `userVeVacaciones`, la MISMA función que usa el `check` del módulo en PortalLayout. Con
 * la regla escrita dos veces, retirársela al chofer en el sidebar lo dejaba viéndola igual
 * acá. El contenido sensible de la pestaña (el costo) se gatea ADENTRO, no escondiéndola:
 * quien no ve montos igual necesita saber quién está fuera.
 */
export default function DashboardTabBar({ tab, setTab, hasNomina, hideTabs }) {
  const { user } = useAuth();
  if (hideTabs) return null;

  const tabs = [
    { key: 'gastos', label: 'Gastos' },
    ...(hasNomina ? [{ key: 'nomina', label: 'Nómina' }] : []),
    ...(userVeVacaciones(user) ? [{ key: 'vacaciones', label: 'Vacaciones' }] : []),
  ];

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      <h2 style={{ fontSize: 20, fontWeight: 700, color: NAVY, margin: 0, marginRight: 16 }}>Dashboard</h2>
      <div style={{ display: 'flex', borderBottom: `1px solid ${BORDER_COLOR}` }}>
        {tabs.map(({ key, label }) => (
          <button key={key} onClick={() => setTab(key)} style={{
            background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'Inter, sans-serif',
            fontSize: 14, fontWeight: tab === key ? 700 : 500,
            color: tab === key ? NAVY : '#94a3b8',
            padding: '6px 16px',
            borderBottom: tab === key ? `2px solid ${AMBER}` : '2px solid transparent',
          }}>
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}
